<template>
    <Layout>
        <!-- Start Slider Area -->
        <div class="slider-area slider-style-1 variation-4" style="background-color: #FFFFFF">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="inner">
                            <br/>
                            <br/>
                            <br/>
                            <span class="subtitle text-center">
                                自动续费条款
                            </span>
                            <br/>
                            <span class="description text-start" style="font-weight: 400;">
                                本版本更新时间：2022年11月15日<br>
                                <br>
                            </span>
                            <span class="description text-start" style="font-weight: 400;">
                                本规则被视为《ROWORLD用户协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。如本规则与《用户协议》存在冲突的，以本规则为准。<br><br>您点击订阅、开通及使用ROWORLD自动续费服务（以下称“本自动续费服务”），则视为您同意本规则。<br><br>您理解并同意：<br><br>1. 自动续费服务是指在会员已购买ROWORLD会员服务的前提下，出于会员对于自动续费的需求，避免会员因疏忽或其他原因导致未能及时续费而推出的服务。如您通过苹果公司Apple ID开通本自动续费服务，且在下一个订阅期前24小时前未主动明确取消本自动续费服务，则苹果公司将在每个订阅期即将到期前24小时，从您开通本自动续费服务时绑定的Apple ID账户（以下统称“账户”）中自动代扣下一个订阅期服务费，从而延长该订阅期对应的会员有效期。您应关注上述账户及可扣款余额状况，如因账户问题或余额不足导致续费失败等风险及/或损失将由您自行承担。<br><br>2.如您通过非苹果支付方式开通本服务，且在会员到期前1天前未主动明确取消本自动续费服务，则相关主体将在会员到期日当天和到期后，从您开通本自动续费服务时绑定的自有充值账户、绑定的第三方支付账户（如支付宝、微信）等账户（以下统称“账户”）中自动代扣下一个订阅期服务费，从而延长该订阅期对应的会员有效期。您应关注上述账户及可扣款余额状况，如因账户问题或余额不足导致续费失败等风险及/或损失，由您自行承担。<br><br>3. 为便于您了解自动续费情况，ROWORLD会根据法律规定，在下一个订阅期扣款前以【站内信、微信推送或邮件】等方式通知您，请您注意接收。提醒您特别注意，基于自动续费服务的特点，自动代扣将在下一个订阅期前24小时完成，如果您未在此之前明确取消自动续费服务，ROWORLD将根据您的委托向相关主体发出下一个订阅期的代扣指令，原则上对基于该指令扣除的费用将不予退还。<br><br>4.订阅期：1个月、3个月、1年等（以订阅页面设置为准），会员可自行选择。<br><br>5. 自动续费用户退订方法如下：<br><br>（1）Apple ID 购买：<br><br>iOS12及以上系统：打开苹果iOS设备“App Store” --> 点击右上角苹果账户头像-->进入“账户”--> 点击“订阅”-->选择ROWORLD，取消订阅即可；<br><br>iOS12以下系统：打开苹果iOS设备“设置” --> 进入“iTunes Store 与 App Store”-->点击“Apple ID”，选择"查看Apple ID"，进入"账户设置"页面，点击“订阅”， 选择ROWORLD，取消订阅即可。<br><br>如未在订阅期到期24小时前取消自动续费功能，将会自动续订及扣款。<br><br>（2）微信、支付宝购买：<br><br>您可以在ROWORLD “我的”-帮助-选择“管理自动续费”，微信扫码后打开“续费与开通记录”页面，找到“[-]”，关闭自动续费，关闭后服务到期将不再自动续费。<br><br>ROWORLD APP→我的→我的会员→进入会员信息页→点击右上角入口进入“签约续费管理”→取消自动续费;<br><br>具体操作方式根据客户端版本更新可能不同。您也可直接在微信、支付宝客户端进行操作，具体操作方式以微信、支付宝客户端为准； <br><br>自动续费状态更新可能存在显示延时，以ROWORLD APP内自动续费签约状态为准。<br><br>如未在会员到期日之前取消自动续费功能，将会自动续订及扣款。<br><br>6. ROWORLD亦可以根据运营策略需要而停止继续向您提供自动续费服务，您的服务期限自当前服务周期届满之日起终止。<br><br>7. <router-link to="/userAgreement">用户协议</router-link><br><br>8. <router-link to="/privacyPolicy">隐私协议</router-link><br><br><br>北京健入家境体育科技有限公司<br>
                            </span>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Slider Area -->

    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'

    export default {
        name: 'AutomaticRenewal',
        components: {Layout},
        data() {
            return {
                
            }
        }
    }
</script>
